import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import BaseSlider from 'components/sliders/Slider';

import styles from './styles.module.scss';

const OffsetSlider = ({ params, containerWidth, ...props }) => {
	const containerRef = useRef(null);
	const getOffsetLeft = useCallback(
		() =>
			containerRef && containerRef.current
				? containerRef.current.offsetLeft
				: 0,
		[containerRef]
	);

	const sliderParams = {
		slidesOffsetBefore: getOffsetLeft,
		slidesOffsetAfter: getOffsetLeft,
		...params
	};

	return (
		<div>
			<div
				className={cx(styles.container, styles[`width_${containerWidth}`])}
				ref={containerRef}
			/>
			<div>
				<BaseSlider {...props} params={sliderParams} />
			</div>
		</div>
	);
};

OffsetSlider.propTypes = {
	params: PropTypes.object,
	containerWidth: PropTypes.oneOf(['default', 'narrow'])
};

OffsetSlider.defaultProps = {
	containerWidth: 'default'
};

export default OffsetSlider;
